<template>
	<el-dialog
		:visible.sync="innerVisible"
		custom-class="c-custom-dialog"
		:before-close="handleClose"
		:close-on-click-modal="false"
	>
		<el-image
			src="https://comein-image.oss-cn-hangzhou.aliyuncs.com/web/irm/web/calendar/fade_1.png"
			fit="cover"
			class="c-custom-mask-img"
		></el-image>
		<div class="s-dialog-title">{{ $t('enterprise.appointment-survey') }}</div>
		<div class="s-dialog-body" ref="previewPoster">
			<div class="body-qrcode">
				<img v-if="posterQrCodeUrl" :src="posterQrCodeUrl" alt="" />
			</div>
		</div>

		<div class="qrcode-canvas" ref="shadowCanvas"></div>
	</el-dialog>
</template>

<script setup>
import { ref, computed, nextTick } from 'vue';
import * as QRCode from 'easyqrcodejs';
import { useCommonData } from '@/hooks';

const props = defineProps({
	visible: {
		type: Boolean,
		default: false
	}
});
const emits = defineEmits(['update:visible', 'submit']);

const innerVisible = computed({
	get: () => {
		if (props.visible) qrcodeDataURL();
		return props.visible;
	},
	set: val => {
		emits('update:visible', val);
	}
});
const handleClose = () => {
	innerVisible.value = false;
};

const { getColumnData, COLOR_LAOPU, generateMobileModuleUrl } = useCommonData();

const shadowCanvas = ref();
const posterQrCodeUrl = ref('');
const qrcodeDataURL = () => {
	const { logo } = getColumnData.value;

	const qrcodeURL = generateMobileModuleUrl('appointment');
	const width = 256;
	const height = 256;
	const config = {
		colorDark: COLOR_LAOPU, //二维码颜色
		colorLight: '#fff', //二维码背景色
		correctLevel: QRCode.CorrectLevel.M, //容错率，L/M/H
		logo: logo,
		crossOrigin: 'anonymous',
		quietZone: 0,
		width,
		height,
		logoWidth: width / 5,
		logoHeight: height / 5
	};
	nextTick(() => {
		new QRCode(shadowCanvas.value, {
			...config,
			text: qrcodeURL,
			onRenderingEnd: (options, dataURL) => {
				posterQrCodeUrl.value = dataURL;
			}
		});
	});
};

const previewPoster = ref();
</script>

<style lang="less" scoped>
/deep/.c-custom-dialog {
	width: 300px;
	background: linear-gradient(180deg, #e3eaff 0%, #fff 19.44%);

	.c-custom-mask-img {
		position: absolute;
		top: 0;
		right: 0;
		width: 300px;
		height: 128px;
		pointer-events: none;
	}

	.el-dialog__header {
		padding: 0;
		border-bottom: none;

		.el-dialog__title {
			color: #1d2129;
			 
			font-size: 20px;
			 
			font-weight: 500;
			line-height: 28px; /* 140% */
		}
	}
	.el-dialog__headerbtn {
		top: 16px;
		right: 16px;
	}
	.el-dialog__body {
		padding: 0;
		padding-bottom: 60px;
	}
}

.s-dialog-title {
	text-align: center;
	color: #1d2129;
	text-align: center;
	 
	font-size: 20px;
	 
	font-weight: 500;
	line-height: 28px; /* 140% */

	position: absolute;
	top: 48px;
	left: 0;
	right: 0;

	&::after {
		content: '';
		position: absolute;
		top: 0;
		left: -50%;
		right: -50%;
		bottom: -16px;
		margin: auto;
		pointer-events: none;
		transform: scaleX(0.5);

		background: linear-gradient(to left, transparent 0%, transparent 50%, #e5e6eb 50%, #e5e6eb 100%);
		background-size: 20px 1px;
		background-repeat: repeat-x;
		background-position-y: 100%;
	}
}
.s-dialog-body {
	margin-top: 72px;
	text-align: center;

	.body-qrcode {
		margin: 0 auto;
		margin-top: 116px;
		width: 170px;
		height: 170px;

		img {
			width: 100%;
			height: 100%;
		}
	}
}

.qrcode-canvas {
	width: 0;
	height: 0;
	display: none;
}
</style>
